/**
 * Trims selectors to generate consistent hashes.
 */
export function trimSelector(selector) {
    return selector.replace(/>\s+/g, '>');
}
//# sourceMappingURL=trimSelector.js.map